import { FieldsBase } from './fields-base';

export class FieldsSelected extends FieldsBase<string> {
  controlType = 'selected';
  options: {key: string, value: string}[] = [];

  constructor(options: {} = {}) {
    super(options);
    this.options = options['options'] || [];
  }
}